import { getConfig } from 'modules/App/config';
import { requestHasEnoughAssets } from 'modules/Auth/request-has-enough-assets';

export const fetchContactsLimit = async () => {
  const { apiContactsService } = await getConfig();
  return requestHasEnoughAssets(`${apiContactsService}`);
};
